import produce from 'immer';
import * as actionTypes from '../actionTypes';
import { IUserState } from '../types';
import { UserActionTypes } from './../types';

export const initialUserState: IUserState = {
  enabledFeatures: undefined,
  loadingEnabledFeatures: false,
  isInitialDataLoaded: false,
};

export const userReducer = produce(
  (
    draft: IUserState = initialUserState,
    action: UserActionTypes,
  ): IUserState => {
    switch (action.type) {
      case actionTypes.LOAD_USER_SUCCESS:
        draft.enabledFeatures = action.payload.enabledFeatures;
        draft.loadingEnabledFeatures = false;
        break;
      case actionTypes.LOAD_USER_REQUEST:
        draft.loadingEnabledFeatures = true;
        break;
      case actionTypes.LOAD_USER_FAILURE:{
        draft.loadingEnabledFeatures = false;
        break;
      }
      case actionTypes.SET_IS_INITIAL_DATA_LOADED: {
        draft.isInitialDataLoaded = true;
        break;
      }
      case actionTypes.GARMIN_ACCEPTED_AUTHORIZATION_SUCCESS: {
        draft.garminIsEnabledForUser = action.payload.isAuthorized;
        break;
      }
      case actionTypes.GARMIN_ACCEPTED_AUTHORIZATION_REQUEST: {
        break;
      }
      case actionTypes.GARMIN_ACCEPTED_AUTHORIZATION_FAILURE: {
        draft.garminIsEnabledForUser = false;
        break;
      }
    }
    return draft;
  },
);
